module.exports = __webpack_public_path__ + "fonts/ZingRust.1ca95fe3.otf";